import { CSSProperties } from 'react';
import AdCreatorPage from './AdCreatorPage';

interface AdFormData {
    spotifyLink: string;
    trackData: any;
    assets: any[];
    budget: string;
    startDate: Date | null;
    endDate: Date | null;
}

const AdCreatorDemo = () => {
    const handleSubmit = (data: AdFormData) => {
        console.log('Ad campaign submitted:', data);
        
        // Here you would typically:
        // 1. Send the data to your backend API
        // 2. Show a success message
        // 3. Redirect the user or update the UI
        
        alert(`Campaign submitted successfully!\n\nMusic: ${data.trackData?.name || 'None'}\nAssets: ${data.assets.length}\nBudget: $${data.budget}/day\nStart: ${data.startDate?.toLocaleDateString()}\nEnd: ${data.endDate?.toLocaleDateString()}`);
    };

    return (
        <div className="adCreatorDemoComponent" style={sty.adCreatorDemoComponent}>
            <AdCreatorPage
                className="adCreatorPage"
            />
        </div>
    );
};

const sty: Record<string, CSSProperties> = {
    adCreatorDemoComponent: {
        width: '100%',
        height: '100vh',
    },
};

export default AdCreatorDemo; 